module.exports = __webpack_public_path__ + "img/683.a938f54f.png";